import { ThemeColors } from '@tribeplatform/design-system/types'

import { getPropertyValue } from '../utils/index.js'

export const colorStylesFactory = (document: Document) => [
  getPropertyValue(document, '--bm-color-decorative-content-1'),
  getPropertyValue(document, '--bm-color-decorative-content-2'),
  getPropertyValue(document, '--bm-color-decorative-content-3'),
  getPropertyValue(document, '--bm-color-decorative-content-4'),
  getPropertyValue(document, '--bm-color-decorative-content-5'),
  getPropertyValue(document, '--bm-color-decorative-content-6'),
  getPropertyValue(document, '--bm-color-decorative-content-7'),
  getPropertyValue(document, '--bm-color-decorative-surface-1'),
  getPropertyValue(document, '--bm-color-decorative-surface-2'),
  getPropertyValue(document, '--bm-color-decorative-surface-3'),
  getPropertyValue(document, '--bm-color-decorative-surface-4'),
  getPropertyValue(document, '--bm-color-decorative-surface-5'),
  getPropertyValue(document, '--bm-color-decorative-surface-6'),
  getPropertyValue(document, '--bm-color-decorative-surface-7'),
]

export const getDecorativeColorsFromThemeColors = (
  currentThemeColors: ThemeColors,
) => [
  currentThemeColors['decorative-content-1'],
  currentThemeColors['decorative-content-2'],
  currentThemeColors['decorative-content-3'],
  currentThemeColors['decorative-content-4'],
  currentThemeColors['decorative-content-5'],
  currentThemeColors['decorative-content-6'],
  currentThemeColors['decorative-content-7'],
  currentThemeColors['decorative-surface-1'],
  currentThemeColors['decorative-surface-2'],
  currentThemeColors['decorative-surface-3'],
  currentThemeColors['decorative-surface-4'],
  currentThemeColors['decorative-surface-5'],
  currentThemeColors['decorative-surface-6'],
  currentThemeColors['decorative-surface-7'],
]

export const randomColor = (colorStyles: string[], index = 0): string => {
  return colorStyles[index % colorStyles.length]
}
